module.exports = __webpack_public_path__ + "static/media/Icons_Notification_Question.8078acc8.svg";